var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17" }, props),
    React.createElement(
      "g",
      { fill: "none", transform: "translate(1 1)" },
      React.createElement("circle", { cx: "7.5", cy: "7.5", r: "7.5", stroke: "#43C6AC" }),
      React.createElement("path", { fill: "#43C6AC", d: "M8.75 9.33V4h-2.5v5.33H5L7.5 12 10 9.33z" })
    )
  );
});